import type { SVGProps } from 'react'

interface NaturePeopleIconProps extends SVGProps<SVGSVGElement> {}

export function NaturePeopleIcon(props: NaturePeopleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M181.63-492.31q-22.63 0-37.51-14.79-14.89-14.8-14.89-37.42 0-22.63 14.8-37.52 14.79-14.88 37.42-14.88 22.63 0 37.51 14.8 14.89 14.79 14.89 37.42 0 22.63-14.8 37.51-14.79 14.88-37.42 14.88ZM229.23-150h342.31v-222.31h-80q-62.92 0-106.46-43.34Q341.54-459 341.54-520q0-48.38 27.92-86.81 27.93-38.42 71.77-57.65 6.77-64.23 53.39-106.04 46.61-41.81 106.92-41.81t106.92 41.81q46.62 41.81 53.38 106.04 43.85 19.23 71.77 57.65 27.93 38.43 27.93 86.81 0 61-43.54 104.35-43.54 43.34-106.46 43.34h-80V-150h170q12.75 0 21.37 8.63 8.63 8.63 8.63 21.38 0 12.76-8.63 21.37Q814.29-90 801.54-90H170q-15.36 0-25.76-10.35-10.39-10.35-10.39-25.65v-144q-11-6.77-23.19-14.04-12.2-7.27-12.2-21.34v-116.93q0-12.75 8.63-21.37 8.62-8.63 21.37-8.63h106.15q12.75 0 21.38 8.63 8.62 8.62 8.62 21.37v116.93q0 14.07-12.19 21.34T229.23-270v120Zm262.31-282.31h220q37.61 0 63.81-25.33 26.19-25.33 26.19-62.36 0-29.69-17.39-53.04-17.38-23.34-45.07-35.11l-33.54-14.16-3.69-34.77q-3.7-40.07-32.16-67.65-28.46-27.58-68.15-27.58-39.69 0-68.16 27.58-28.46 27.58-32.15 67.65l-3.69 34.77L464-608.15q-27.69 11.77-45.08 35.11-17.38 23.35-17.38 53.04 0 37.03 26.19 62.36t63.81 25.33Zm110-160Z" />
    </svg>
  )
}
